"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
const dotsIdentifier_1 = require("./factor/dotsIdentifier");
const boolLiteral_1 = require("./factor/boolLiteral");
const numberLiteral_1 = require("./factor/numberLiteral");
const stringLiteral_1 = require("./factor/stringLiteral");
const parenthesisExpression_1 = require("./factor/parenthesisExpression");
const ArrayExpression_1 = require("./factor/ArrayExpression");
const arrayElement_1 = require("./factor/arrayElement");
const objectLiteral_1 = require("./factor/objectLiteral");
exports.factor = ({ ast, execObject }) => {
    if (ast.children.NumberLiteral) {
        return numberLiteral_1.numberLiteral({ ast, execObject });
    }
    else if (ast.children.DotsIdentifier) {
        return dotsIdentifier_1.dotsIdentifier({ ast, execObject });
    }
    else if (ast.children.BoolLiteral) {
        return boolLiteral_1.booleanLiteral({ ast, execObject });
    }
    else if (ast.children.StringLiteral) {
        return stringLiteral_1.stringLiteral({ ast, execObject });
    }
    else if (ast.children.parentheses) {
        return parenthesisExpression_1.parenthesisExpression({ ast, execObject });
    }
    else if (ast.children.arrayExpression) {
        return ArrayExpression_1.arrayExpression({ ast, execObject });
    }
    else if (ast.children.arrayElement) {
        return arrayElement_1.arrayElement({ ast, execObject });
    }
    else if (ast.children.object) {
        return objectLiteral_1.objectLiteral({ ast, execObject });
    }
    return {
        name: tokens_1.LiteralTokens.DebugLiteral,
        image: null,
    };
};
